// post form
$('form#polymer-config-form button[type="submit"]').click(function (event) {

    event.preventDefault();
    event.stopPropagation();

    $('#config-text').text($('#config').text());

    $('form#polymer-config-form').submit();
});


// WEBPACK FOOTER //
// ./resources/assets/js/polymer-config.js